/* eslint-disable */
export default {
  today: 'Hoje',
  yesterday: 'Ontem',
  empty: 'Sem registros de chamada',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
